import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[portalAccordion]',
  standalone: false
})
export class AccordionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
